// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__9g9Ly","container":"styles_container__3NvEG","title":"styles_title__2MNs3","wrapper":"styles_wrapper__2tJwX","answer":"styles_answer__3zhTi"};